import queryString from 'query-string';

import { URLThemeType } from '@/const/enums';

export const getThemeType = (): URLThemeType => {
  const theme = queryString.parse(window.location.search).theme;
  return theme ? (theme as URLThemeType) : URLThemeType.Light;
};
